<template>
    <MainPage @clickBack="clickBack()">
        <div class="w-full lg:w-554px mx-auto rounded-10 lg:rounded-12">
            <TabMenu @updateActiveMenu="updateActiveMenu($event)"></TabMenu>
            <div>
                <MenuList v-if="activeList == 'menu'"></MenuList>
                <OrderList v-if="activeList == 'order'" class="mt-6"></OrderList>
            </div>
        </div>
    </MainPage>
</template>
<script>
// components
import MainPage from '@/components/Layout/Page/MainPage.vue';
import TabMenu from '../component/TabMenu.vue';
import MenuList from '../component/MenuList.vue';
import OrderList from '../component/OrderList.vue';
// mixins
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "MyFavorite",
    mixins: [LocaleMixin],
    components: {
        MainPage,
        TabMenu,
        MenuList,
        OrderList
    },
    data: function() {
        return {
            activeList: 'menu',
        }
    },
    created() {
        this.tracking.screenName('favorite');
        this.tracking.event('favorite','view favorite list');
    },
    methods: {
        updateActiveMenu: function(activeMenu){
            this.activeList = activeMenu;
        },
        clickBack: function(){
            this.$router.back();
        },
    },

}
</script>
